import {format as dateFnsFormat, parseISO, parse} from 'date-fns';

type Format =
  | 'dd.MM.yyyy, HH:mm'
  | 'dd.MM.yyyy HH:mm'
  | 'HH:mm dd.MM.yyyy'
  | 'HH:mm, dd.MM.yyyy'
  | 'dd.MM.yyyy'
  | 'MM/dd/yyyy HH:mm:ss'
  | 'MM/dd/yyyy HH:mm';

function toValidDate(input: Date | string | number): Date | null {
  if (input instanceof Date) {
    const t = input.getTime();
    return Number.isNaN(t) ? null : input;
  }

  if (typeof input === 'number') {
    const ms = input < 1e12 ? input * 1000 : input;
    const d = new Date(ms);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  if (typeof input === 'string') {
    const trimmed = input.trim();

    // Numeric string timestamp
    if (/^\d+$/.test(trimmed)) {
      const n = parseInt(trimmed, 10);
      return toValidDate(n);
    }

    // Try ISO first
    try {
      const iso = parseISO(trimmed);
      if (!Number.isNaN(iso.getTime())) return iso;
    } catch {}

    // Try common custom formats
    const candidates: Format[] = [
      'dd.MM.yyyy, HH:mm',
      'dd.MM.yyyy HH:mm',
      'HH:mm dd.MM.yyyy',
      'HH:mm, dd.MM.yyyy',
      'dd.MM.yyyy',
      'MM/dd/yyyy HH:mm:ss',
      'MM/dd/yyyy HH:mm',
    ];
    for (const pattern of candidates) {
      try {
        const d = parse(trimmed, pattern, new Date());
        if (!Number.isNaN(d.getTime())) return d;
      } catch {}
    }

    // Fallback to native parser
    const d = new Date(trimmed);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  return null;
}

export function formatDate(date: Date | string | number, fallback: string = '—') {
  const d = toValidDate(date);
  if (!d) return fallback;
  return d.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function formatDateTime(
  dateTime: Date | string | number,
  format: Format = 'dd.MM.yyyy, HH:mm',
  fallback: string = '—',
) {
  const d = toValidDate(dateTime);
  if (!d) return fallback;
  return dateFnsFormat(d, format);
}
